import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary, $textSecondary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'
import DeliveryTruckIcon from '../../../icons/checkout/DeliveryTruckIcon'
import { $white } from '../../../../styles/colors/primitives'
import AnnounceIcon from '../../../icons/AnnounceIcon'
import CouponIcon from '../../../icons/CouponIcon'
import PedalIcon from '../../../icons/PedalIcon'
import HighFiveIcon from '../../../icons/HighFiveIcon'
import ShirtIcon from '../../../icons/ShirtIcon'

function Step5() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">05</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>We give you rewards and benefits</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Participating in the VRS Creators Program is not only about showcasing your skills and passion for sim racing; it’s also about reaping tangible rewards and benefits that enhance your experience and contributions. As you continue to deliver high-quality content, you’ll unlock various rewards that recognize your efforts and help propel your creative journey forward.</Text>
          <Spacer size={32}/>
          <div className={styles.iconAndBenefit}>
            <div className={styles.icon}>
              <CouponIcon fill={$white}/>
            </div>
            <div className={styles.benefit}>
              <Text type="heading-4" color={$textPrimary.dark}>Exclusive discounts</Text>
              <Text type="large" color={$textPrimary.dark}>Enjoy special discounts on VRS hardware and software.</Text>
            </div>
          </div>
          <div className={styles.iconAndBenefit}>
            <div className={styles.icon}>
              <PedalIcon fill={$white}/>
            </div>
            <div className={styles.benefit}>
              <Text type="heading-4" color={$textPrimary.dark}>Free gear</Text>
              <Text type="large" color={$textPrimary.dark}>We are giving away 10x VRS® Lite Formula Wheels!</Text>
            </div>
          </div>
          <div className={styles.iconAndBenefit}>
            <div className={styles.icon}>
              <ShirtIcon fill={$white}/>
            </div>
            <div className={styles.benefit}>
              <Text type="heading-4" color={$textPrimary.dark}>Free merchandise</Text>
              <Text type="large" color={$textPrimary.dark}>Receive limited-edition VRS merchandise and exclusive gear that highlights your support for the brand.</Text>
            </div>
          </div>
          <div className={styles.iconAndBenefit}>
            <div className={styles.icon}>
              <AnnounceIcon fill={$white}/>
            </div>
            <div className={styles.benefit}>
              <Text type="heading-4" color={$textPrimary.dark}>Social media shoutouts</Text>
              <Text type="large" color={$textPrimary.dark}>Get recognized within the sim racing community by being featured on VRS’s official social media channels, reaching thousands of fans worldwide.</Text>
            </div>
          </div>
          <div className={styles.iconAndBenefit}>
            <div className={styles.icon}>
              <HighFiveIcon fill={$white}/>
            </div>
            <div className={styles.benefit}>
              <Text type="heading-4" color={$textPrimary.dark}>Collaborations and sponsorships</Text>
              <Text type="large" color={$textPrimary.dark}>Stand out with your content and unlock potential collaboration or sponsorship deals with VRS.</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step5
